import { derived, get, writable } from 'svelte/store';
;
const audioFileToPlay = writable(null);
export const currentlyPlayedAudioFile = derived(audioFileToPlay, audioFileToPlay => audioFileToPlay);
export const audioProgress = writable(0);
const player = new Audio();
let progressMonitorInterval;
function monitorAudioProgress() {
    progressMonitorInterval = setInterval(() => {
        if (!player.paused && player.duration > player.currentTime) {
            const progressPercent = Math.round(100 * player.currentTime / player.duration);
            const prevProgress = get(audioProgress);
            if (prevProgress != progressPercent) {
                audioProgress.set(progressPercent);
            }
        }
    }, 33);
}
player.onplaying = monitorAudioProgress;
player.onended = () => {
    if (progressMonitorInterval) {
        clearInterval(progressMonitorInterval);
    }
    progressMonitorInterval = undefined;
};
player.onended = () => {
    audioFileToPlay.set(null);
    audioProgress.set(0);
};
audioFileToPlay.subscribe(entry => {
    if (entry) {
        player.pause();
        const fullFileUrl = `https://glosbe.com/fb_aud/mp3/${entry.url}`;
        if (player.src === fullFileUrl) {
            player.currentTime = 0;
            player.play();
        }
        else {
            player.src = fullFileUrl;
            player.play();
        }
    }
    else {
        player.removeAttribute("src");
    }
});
export function playAudioFile(entry) {
    audioFileToPlay.set(Object.assign({}, entry));
}
export function playAudioFileByAudioEntry(entry) {
    playAudioFile({ phrase: entry.phrase, url: entry.url.mp3, id: entry.fbFileId });
}
export function toggleAudioPlayback() {
    if (player.paused) {
        player.play();
    }
    else {
        player.pause();
    }
}
export function pauseAudioPlayback() {
    player.pause();
}
export function playAudioFileByUrlAndId(entry) {
    playAudioFile(entry);
}
